<template>
  <div :style="areaStyle">
    <graphicTitleBar
      :titleData="data"
      @moduleMargeType="true"
    />
    <div class="graphic-combination-container"
         v-if="specialEntryList.length">
      <!--      <a class="button btn-text-align" @click="jumpUrlButton(buttonData)" :class="isLinkBtnClass" v-if="buttonData.isShowButton && specialStyle.linkBtnLocation == 'top'">{{buttonData.buttonName}}</a>-->
      <div class="graphic-box">
        <div class="graphic-column"
             ref="graphics"
             :style="graphicColumnStyl"
             :class="{
          'is-oneline': specialData.showRows == 1 && !isLeftRight,
          'is-left-right': isLeftRight,
          'is-flex': /2|4|5|6|8/.test(specialData.templateType)
          }"
        >
          <template v-for="(item, index) in specialEntryList">
            <component
              :is="view"
              class="graphic-item"
              :style="componentStyl"
              ref="items"
              @click.native.prevent="jumpUrl(item)"
              :data="data"
              :item="item"
              :key="index"
              :default-img="defaultImg"
            ></component>
          </template>
        </div>
      </div>
      <!--      <a class="button" @click="jumpUrlButton(buttonData)" :class="isLinkBtnClass" v-if="buttonData.isShowButton && specialStyle.linkBtnLocation == 'bottom' || specialStyle.linkBtnLocation == ''">{{buttonData.buttonName}}</a>-->
    </div>
    <div slot="empty" v-else>
      <div class="empty-tip">
        <img src="../asset/images/tp-zwsj@2x.png" alt="">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>
<script>
import defaultImg from '../asset/images/default-img.png'
import {commonClickFn, checkMoreClickFn} from './clickJs'

const modulesTemp = {
  '1': 'graphicOne',
  '2': 'graphicTwo',
  '3': 'graphicThree',
  '4': 'graphicFour',
  '5': 'graphicFive',
  '6': 'graphicSix',
  '7': 'graphicSeven',
  '8': 'graphicEight'
}
export default {
  name: 'graphicCombination',
  data() {
    const {tempData: {specialData, specialStyle, buttonData}, terminal} = this.data
    return {
      defaultImg,
      specialData,
      specialStyle,
      specialEntryList: [],
      buttonData,
      terminal,
    }
  },

  computed: {
    graphicColumnStyl(){
      const {topBottomInterval } = this.specialStyle
      // let {showRows} = this.specialData
      return{
        marginBottom: `-${topBottomInterval}px`,
        // overflow: showRows==1?'auto': '' // 错位问题
      }
    },
    componentStyl(){
      let {topBottomInterval } = this.specialStyle
      return {
        marginBottom: `${topBottomInterval}px`,
      }
    },
    isLinkBtnClass() {
      return this?.specialStyle?.linkBtnAlign ?? ''
    },
    isLeftRight() {
      const {templateType} = this.specialData
      return (templateType == 1 || templateType == 2 || templateType == 7 || templateType == 8) ? true : false
    },
    view() {
      return this.specialData.templateType ? modulesTemp[this.specialData.templateType] : 'graphicOne'
    },
    areaStyle() {
      const {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor
      } = this.specialStyle;
      return {
        marginTop: `${blockMargeTop ? blockMargeTop : 0}px`,
        marginBottom: `${blockMargeBottom ? blockMargeBottom : 0}px`,
        backgroundColor: blockBGClolor ? blockBGClolor : 'none',
      }
    },
    parentClassName() {
      return modulesTemp[this.specialData.templateType]
    }
  },
  props: {
    data: {
      type: Object,
    }
  },
  components: {
    graphicOne: () => import('./graphicComponent/graphicOne.vue'),
    graphicTwo: () => import('./graphicComponent/graphicTwo.vue'),
    graphicThree: () => import('./graphicComponent/graphicThree.vue'),
    graphicFour: () => import('./graphicComponent/graphicFour.vue'),
    graphicFive: () => import('./graphicComponent/graphicFive.vue'),
    graphicSix: () => import('./graphicComponent/graphicSix.vue'),
    graphicTitleBar: () => import('./graphicComponent/graphicTitleBar.vue'),
    graphicSeven: () => import('./graphicComponent/graphicSeven.vue'),
    graphicEight: () => import('./graphicComponent/graphicEight.vue')
  },
  methods: {
    resetData(data) {
      return data.map((item) => {
        return {
          entryImg: item.articleCover,
          articleId: item.id,
          titleName: item.articleTitle,
          titleDes: item.articleAbstract,
          publishTime: item.publishTime,
          selectType: 1,
          articleType: item.articleType,
          articleVideoUrl: item.articleVideoUrl,
          enclosureType: item.enclosureType,
          enclosureUrl: item.enclosureUrl,
          fileType: item.articleVideoUrl ? 2 : '',
          readNum: item.readNum
        }
      })
    },
    async getList() {
      const {showRows, templateType, showTotal, commendsRule} = this.specialData
      console.log(this.$api.cms, 'fasdfsafds')
      const res = await this.$apis.cms.getArticleDetail({
        classId: this.specialData.articleClassID,
        sort: commendsRule,
        pageNum:1,
        pageSize:10000
        // classId: '176'
      })
      if (showTotal) {
        this.specialEntryList = showTotal < res.data.list.length ? this.resetData(res.data.list.slice(0, showTotal)) : this.resetData(res.data.list)
      } else {
        this.specialEntryList = this.resetData(res.data.list)
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.isScroll(showRows, templateType)) {
            this.scrollContent(templateType)
          }
        }, 200)
      })
    },

    // 按钮跳转
    jumpUrlButton(buttonData) {
      checkMoreClickFn(buttonData, this.specialData, this)
    },
    //跳转
    jumpUrl(item) {
      console.log('click', item)
      commonClickFn(item, this.specialData, this)
    },
    scrollContent(templateType) {
      const w = document.querySelectorAll('.graphic-item')[0].getBoundingClientRect().width
      if (this.$refs?.graphics) {
        this.$refs.graphics.scrollLeft = templateType == 3 ? w / 3 + 6 : w / 2 + 6
      }
    },
    isScroll(showRows, templateType) {
      return showRows == 1 && /3|4|5|6/.test(templateType)
    },

    // 数组处理 通过图片id 视频id 请求最新的图片地址 视频地址
    getImageInfoList(articleDataList) {
      let idList = []
      articleDataList.map((item) => {
        idList.push(item.fileId)
      })
      console.log(idList, 'fsdfasdfasdf')
      this.$apis.cms.getImageList(idList).then(res => {
        let ImageInfoList = res.data
        articleDataList.map((item, index) => {
          ImageInfoList[index] && (item.entryImg = ImageInfoList[index].thumbnail)
        })
      })
    }
  },
  async mounted() {
    this.$nextTick(() => {
      if (this.specialData.showContentType == 2) {
        this.getList()
      } else if (this.specialData.showContentType == 1) {
        // this.getList()
        const {tempData: {specialData, specialEntryList}} = this.data

        let list = []
        if (Array.isArray(specialEntryList)) {
          if (specialData.showTotal) {
            list = specialData.showTotal < specialEntryList.length ? specialEntryList.slice(0, specialData.showTotal) : specialEntryList
          } else {
            list = specialEntryList
          }
        }
        this.specialEntryList = list;
        this.getImageInfoList(this.specialEntryList)
        // console.log(this.getImageInfoList(this.specialEntryList),'909090090909')

        // console.log( this.specialEntryList,' this.specialEntryList')
        // this.specialEntryList =  this.getImageInfoList(this.specialEntryList);

        console.log(this.specialEntryList, 'this.specialEntryList this.specialEntryList');
        // console.log(specialData,'tempDatatempDatatempDatatempData');
        setTimeout(() => {
          const {showRows, templateType} = this.specialData
          if (this.isScroll(showRows, templateType)) {
            this.scrollContent(templateType)
          }
        }, 200)
      }
    })
  }

}
</script>
<style lang="less" scoped>
.graphic-combination-container {
  overflow: hidden;
  // .graphic-box {
  //   overflow: auto;
  // }
  &::-webkit-scrollbar{
    height: 0!important;
  }

  .graphic-column {
    width: 100% !important;
  }

  padding: 24px;
  box-sizing: border-box;

  .is-oneline {
    width: 100%;
    overflow-x: scroll;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;

    &.is-flex {
      display: flex;
      flex-wrap: inherit;
    }

    .graphic-item {
      margin-right: 24px;
      vertical-align: top;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .is-left-right {
    .graphic-item {
      display: flex;
      //align-items: center;
    }
  }

  /deep/ .default-picture {
    width: 100%;
  }

  .is-flex {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  /deep/ .right-cont {
    .graphic-title {
      overflow: hidden;
      text-overflow: ellipsis;
      // -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-align: justify;
      word-break: break-all;
      white-space: nowrap;
    }

    .summary {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: justify;
      word-break: break-all;
    }

  }

  .button {
    display: block;
    margin: 0 auto;
    height: 48px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    text-align: center;

    &.btn-text-align {
      text-align: right;
      margin-bottom: 24px;
    }

    &.center {
      text-align: center;
    }

    &.left {
      text-align: left;
    }

    &.right {
      text-align: right;
    }
  }

  .swiper-wrap {
    width: 100%;

    .swiper-slide {
      width: 100%;
    }
  }
  // 去掉滚动条
  ::-webkit-scrollbar{
    height: 0!important;
    width: 0;
  }
}

.empty-tip {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #D9DEE7;
  margin-top: 100px;
  padding-bottom: 30px;

  img {
    width: 100px;
  }
}
</style>
